/** `formData.get` can return null or a File; callers always want a string. */
export function getByFieldName(formData: FormData, name: string): string {
  const value = formData.get(name);

  return typeof value === 'string' ? value : '';
}
